import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter as Router, Redirect, Route, Switch, withRouter, Link } from "react-router-dom";
import { HashRouter } from 'react-router-dom';

ReactDOM.render(
  <React.StrictMode>
    <HashRouter>
     <App />
    </HashRouter> 
  </React.StrictMode>,
  document.getElementById('root')
);
